import React, {Component} from "react";
import "./SkillStyle.css";

class Skill extends Component{
    constructor(props){
        super(props);
    }
    render(){
        if (this.props.useGhost){
            return <div key={this.props.i} className="skill-chip-blank"></div>;
        }
        return <div key={this.props.i} className="skill-chip">{this.props.skill}</div>;
    }
}

export default Skill;